import React, { FC } from 'react';
import classNames from 'classnames';
import DangerouslySetInnerHtml from 'components/DangerouslySetInnerHtml';
import ValidationMessage from '../ValidationMessage';
import { FieldProps } from '../models';
import './CheckboxField.scss';

const CheckboxField: FC<FieldProps> = (props) => {
  const {
    isRequired = false,
    id,
    type,
    label,
    errorMessage,
    ariaLabel,
    placeholder,
    ts,
    value,
    ...other
  } = props;

  const checked = !!value;
  const errorMessageId = `${id}Error`;

  return (
    <div>
      <div
        className={classNames(`form-field checkbox-field`, {
          'form-field__error': errorMessage,
          'form-field__required': isRequired,
        })}
      >
        <DangerouslySetInnerHtml
          htmlFor={id}
          element="label"
          className="form-field__label"
          html={ts[label]}
        />
        <span
          className={classNames('checkbox-field__icon', {
            'checkbox-field__icon--checked': checked,
          })}
        >
          <input
            type={type}
            aria-invalid={!!errorMessage}
            aria-describedby={errorMessageId}
            aria-label={ts[ariaLabel]}
            id={id}
            value={value}
            {...(placeholder && { placeholder: ts[placeholder] })}
            {...(value && { checked })}
            {...other}
          />
        </span>
      </div>
      {errorMessage && (
        <ValidationMessage errorId={errorMessageId} errorMessage={ts[errorMessage]} />
      )}
    </div>
  );
};

export default CheckboxField;
